<template>
  <section v-if="visible" class="notification v-fade">
    <div>
      <div class="notification__content">
        <div v-if="!hideCloseButton" class="notification__close-btn">
          <a class="notification__close" @click="hide"
            ><span class="notification__close-icon iconfont iclose"></span
          ></a>
        </div>
        <slot name="icon">
          <div class="notification__play-icon">
            <img src="@/assets.app/images/play.svg" alt="" />
          </div>
        </slot>
        <div class="notification__text-box">
          <h2 class="notification__title">
            <slot name="title">
              Introducing Podcasts: Meet the new content platform available now
              on Shortform!
            </slot>
          </h2>
          <p class="notification__text">
            <slot name="text">
              <a href="#">Lorem ipsum dolor</a> Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Lectus a laoreet habitasse sed rutrum
              urna. Ut quam eget aliquam integer ut orci proin facilisis.
            </slot>
          </p>
        </div>
        <div class="notification__btn-box">
          <slot name="link">
            <a href="#" class="btns btns--large">Learn More</a>
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  hideCloseButton?: boolean
}>()

const visible = ref(true)

function hide(): void {
  visible.value = false
}
</script>
